import React, { Component } from "react";
import MainPagesLayout from '../../PageLayout/MainPagesLayout/MainPagesLayout.jsx';
import ProjectSearchResult from "./ProjectSearchResult";
import { Row, Col, Breadcrumb, Form } from 'react-bootstrap';
import Loading from '../../PageLayout/Loading';
import ReactRouterPropTypes from 'react-router-prop-types';
import QueryString from 'query-string';
import { LinkTo } from '../../PageLayout/Link/Link';
import ApiService from '../../Services/ApiService';
import UserListControl from './component/UserListContol';
import moment from 'moment';
import RouterHistory from '../../Router/RouterHistory';
import Spinner from '../../PageLayout/Spinner';
import ClassicTitledTile from '../Project/component/ClassicTitledTile';
import logo from "images/codai.svg";

class ProjectSearchPage extends Component {
  static propTypes = {
    location: ReactRouterPropTypes.location,
  }

  constructor(props) {
    super(props);
    const params = QueryString.parse(location.search);

    let searchRequest = {
      // default search request state
      searchText: params.textSearch ? params.textSearch : '',
      limit: 20,
      orderBy: params.orderBy ? params.orderBy : 'name',

      // setup default filter option
      ...this.getClearedSearchFilter(),
    };
    // read url filter params and overrider
    let filterParams = this.readSearchQueryUrlParams(searchRequest, 0);
    searchRequest = { ...searchRequest, ...filterParams.searchRequest };

    this.state = {
      isLoading: true,
      isLoadingRef: true,

      showFilterTab: searchRequest.searchText == '',
      resultCount: null,
      selectedDateFilter: filterParams.dateFilter ? filterParams.dateFilter : 0,
      selectedUserFilter: [],
      availableCostCenters: [],
      availableTags: [],
      searchRequest
    };
  }

  async componentDidMount() {
    try {
      const data = await ApiService.getRef();

      const costCenter = data?.costcenterRefs?.sort((cc, bb) => cc.displayOrder - bb.displayOrder)
        ?.map(c => ({
          value: c.costcenterRefId,
          displayName: c.costcenterRefDescription
        })) ?? [];
      const tags = data?.tagRefs?.sort((a, b) =>
        a.tagTypeRefId.localeCompare(b.tagTypeRefId) || a.name.localeCompare(b.name)
      ) ?? [];
      let stateUpdate = {
        availableCostCenters: costCenter,
        availableTags: tags,
        isLoadingRef: false
      };

      stateUpdate.availableTags = tags.filter(a => tags.find((b) => b.tagTypeRefId === a.tagTypeRefId) === a)
        .map(tagGroup => ({
          label: tagGroup.tagTypeRef.name,
          tagTypeId: tagGroup.tagTypeRefId,
          options: tags.filter((tag) => tag.tagTypeRefId === tagGroup.tagTypeRefId)
            .map((tag, i) => ({
              value: tag.tagRefId,
              label: tag.name,
              selected: false,
              tagTypeId: tagGroup.tagTypeRefId,
              count: i * 200 % 21, // TODO
            }))
        }));

      this.setState(() => stateUpdate);
    } catch (error) {
      console.error(error);
    }

    // update search text and other option from url when header search input is submit
    setTimeout(() => {
      setInterval(() => {
        let filterParams = this.readSearchQueryUrlParams(this.state.searchRequest, this.state.selectedDateFilter);
        if (Object.keys(filterParams.searchRequest).length > 0 || filterParams.dateFilter != null) {
          let stateUpdate = { isLoading: true };

          if (filterParams.dateFilter != null) {
            stateUpdate.selectedDateFilter = filterParams.dateFilter;
          }
          if (Object.keys(filterParams.searchRequest).length > 0) {
            stateUpdate.searchRequest = { ...this.state.searchRequest, ...filterParams.searchRequest };
          }

          this.setState(stateUpdate);
        }
      }, 500);
    }, 1000);
  }

  getClearedSearchFilter = () => ({
    costCenterId: [],
    tagId: [],
    userEmail: [],
    requesterStar: false,
    creationDateFrom: null,
    creationDateTo: null,
  });

  updateSearchInfo = (results) => {
    this.setState({
      resultCount: results.length,
      isLoading: false,
    });
  }

  readSearchQueryUrlParams(currentSearchRequest, currentDateFilter) {
    const params = QueryString.parse(location.search);
    let dateFilter = null;
    let searchRequest = {};

    if (params.textSearch !== undefined && currentSearchRequest.searchText != params.textSearch) {
      searchRequest.searchText = params.textSearch;
    }
    if (params.orderBy && currentSearchRequest.orderBy != params.orderBy) {
      searchRequest.orderBy = params.orderBy;
    }
    if (params.costCenterId && (currentSearchRequest.length == 0 || currentSearchRequest.costCenterId[0] != params.costCenterId)) {
      searchRequest.costCenterId = [params.costCenterId];
    }
    if (params.tagId) {
      params.tagId = params.tagId.split(',').sort();
      if (currentSearchRequest.tagId.join(',') != params.tagId.join(',')) {
        searchRequest.tagId = params.tagId;
      }
    }
    /* TODO modify UserListControl to accept defaultValue
    if (params.userEmail) {
      params.userEmail = params.userEmail.split(',').sort();
      if (currentSearchRequest.userEmail.sort().join(',') != params.userEmail.join(',')) {
        searchRequest.userEmail = params.userEmail;
      }
    }*/
    if (params.requesterStar && currentSearchRequest.requesterStar != params.requesterStar) {
      searchRequest.requesterStar = params.requesterStar;
    }
    if (params.date) {
      params.date = parseInt(params.date);
      if (params.date >= 0 && params.date < this.possibleDateFilter.length && params.date != currentDateFilter) {
        searchRequest.creationDateFrom = this.possibleDateFilter[params.date].value.from;
        searchRequest.creationDateTo = this.possibleDateFilter[params.date].value.to;
        dateFilter = params.date;
      }
    }

    return { searchRequest, dateFilter };
  }

  writeSearchQueryUrlParams() {
    var queryParams = [];

    if (this.state.searchRequest.searchText) {
      queryParams.push('textSearch=' + encodeURIComponent(this.state.searchRequest.searchText));
    }
    if (this.state.searchRequest.orderBy != 'name') {
      queryParams.push('orderBy=' + encodeURIComponent(this.state.searchRequest.orderBy));
    }
    if (this.state.searchRequest.costCenterId.length > 0) {
      queryParams.push('costCenterId=' + encodeURIComponent(this.state.searchRequest.costCenterId.join(',')));
    }
    if (this.state.searchRequest.tagId.length > 0) {
      queryParams.push('tagId=' + encodeURIComponent(this.state.searchRequest.tagId.join(',')));
    }
    /*
    if (this.state.searchRequest.userEmail.length > 0) {
      queryParams.push('userEmail=' + encodeURIComponent(this.state.searchRequest.userEmail.join(',')));
    }*/
    if (this.state.searchRequest.requesterStar != false) {
      queryParams.push('requesterStar=' + encodeURIComponent(this.state.searchRequest.requesterStar));
    }
    if (this.state.selectedDateFilter != 0) {
      queryParams.push('date=' + encodeURIComponent(this.state.selectedDateFilter));
    }

    RouterHistory.push('/project/search' + (queryParams.length > 0 ? ('?' + queryParams.join('&')) : ''));
  }

  changeSearchRequestFilter = (fieldName, value) => {
    var searchRequest = { ...this.state.searchRequest };

    if (fieldName === 'creationDate') {
      searchRequest.creationDateFrom = this.possibleDateFilter[value].value.from;
      searchRequest.creationDateTo = this.possibleDateFilter[value].value.to;
      this.setState({ searchRequest, selectedDateFilter: value, isLoading: true }, this.writeSearchQueryUrlParams);
    } else if (fieldName == 'userEmail') {
      searchRequest.userEmail = value.map(u => u.value);
      this.setState({ searchRequest, selectedUserFilter: value, isLoading: true }, this.writeSearchQueryUrlParams);
    } else if (searchRequest[fieldName] != value) {
      searchRequest[fieldName] = value;
      this.setState({ searchRequest, isLoading: true }, this.writeSearchQueryUrlParams);
    }
  }

  changeFilterTabVisibility = () => {
    this.setState({ showFilterTab: !this.state.showFilterTab });
  }

  possibleDateFilter = [
    {
      value: { to: null, from: null },
      label: '',
    },
    {
      value: { to: moment().toDate(), from: moment().add(-6, 'M').toDate() },
      label: '<= 6 months',
    },
    {
      value: { to: moment().add(-6, 'M').toDate(), from: moment().add(-12, 'M').toDate() },
      label: '7-12 months',
    },
    {
      value: { to: moment().add(-12, 'M').toDate(), from: moment().add(-24, 'M').toDate() },
      label: '1-2 years',
    },
    {
      value: { to: moment().add(-24, 'M').toDate(), from: moment().add(-1200, 'M').toDate() },
      label: '>= 2 years',
    }
  ];

  render() {

    return (
      <MainPagesLayout className="ProjectSearchPage">
        <Breadcrumb className={'breadCrumb'}>
          <Breadcrumb.Item {...LinkTo('/')}>
            <img alt="CoDAI" src={logo} />
          </Breadcrumb.Item>
          <Breadcrumb.Item {...LinkTo('/')}>
            Home
          </Breadcrumb.Item>
          <Breadcrumb.Item active>
            Search Result
          </Breadcrumb.Item>
        </Breadcrumb>
        <div>
          {this.state.isLoadingRef ? <Loading /> : (
            <ClassicTitledTile
              title={(
                <div className="TitlePage projectSearchHeader">
                  <Row>
                    <Col md={true}>
                      <h1>
                        {this.state.searchRequest.searchText}{'\t'}
                        {!this.state.isLoading ? (
                          <label className="resultCount">{this.state.resultCount} results</label>
                        ) : <Spinner />}
                      </h1>
                    </Col>
                    <Col className="filterExpand" md={2} onClick={this.changeFilterTabVisibility}>
                      <i className="icon-filter" />
                      {this.state.showFilterTab ? 'Close' : 'Open'}{' Filters'}
                    </Col>
                  </Row>
                </div>
              )}
            >
              {this.state.showFilterTab && (
                <div className='advancefilter'>
                  <Row>
                    <Col md={8}>
                      <div className="filterTag">
                        {this.state.availableTags.map((tagGroup, i) => (
                          <div key={i} className="filterTagGroup">
                            <div className="filterTagGroupName">
                              <i className={"icon-tag-" + tagGroup.tagTypeId} />
                              {tagGroup.label}
                            </div>
                            <div className="filterTagGroupItems">
                              {tagGroup.options.map((tag, x) => {
                                const idx = this.state.searchRequest.tagId.indexOf(tag.value);
                                const newval = idx != -1 ? this.state.searchRequest.tagId.filter(selectTagId => selectTagId != tag.value) : [tag.value].concat(this.state.searchRequest.tagId);
                                return (
                                  <div
                                    key={x}
                                    className={'filterTagGroupItem' + (idx != -1 ? ' selectedTag' : '')}
                                    onClick={() => this.changeSearchRequestFilter('tagId', newval.sort())}
                                  >
                                    {tag.label} {/*({tag.count})*/}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        ))}
                      </div>
                    </Col>
                    <Col md={4}>
                      <Form.Group>
                        <Form.Label>Users</Form.Label>
                        <UserListControl
                          value={this.state.selectedUserFilter}
                          onChange={(user) => this.changeSearchRequestFilter('userEmail', user)}
                          disable={false}
                        />
                        <div className='formInputTextHelper'>{'Set search filters by users'}</div>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Creation date</Form.Label>
                        <Form.Control as="select"
                          required
                          value={this.state.selectedDateFilter}
                          onChange={(i) => this.changeSearchRequestFilter('creationDate', i.target.value)}
                        >
                          {this.possibleDateFilter.map((dateFilter, i) =>
                            <option key={i} value={i}>{dateFilter.label}</option>
                          )}
                        </Form.Control>
                        <div className='formInputTextHelper'>{'Set search filters by creation date'}</div>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Cost Center</Form.Label>
                        <Form.Control as="select"
                          required
                          value={this.state.searchRequest.costCenterId.length > 0 ? this.state.searchRequest.costCenterId[0] : ''}
                          onChange={(i) => this.changeSearchRequestFilter('costCenterId', (!i.target.value || i.target.value == '') ? [] : [i.target.value])}
                        >
                          <option key='empty'></option>
                          {this.state.availableCostCenters.map((c) => (
                            <option key={c.value} value={c.value}>{c.displayName}</option>
                          ))}
                        </Form.Control>
                        <div className='formInputTextHelper'>Filter by cost center</div>
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>My favorite?</Form.Label>
                        <Form.Check
                          type="switch"
                          id="custom-switch"
                          checked={this.state.searchRequest.requesterStar ? 'checked' : ''}
                          onChange={() => this.changeSearchRequestFilter('requesterStar', !this.state.searchRequest.requesterStar)}
                          label={<i className={'icon-star-fg icon-star-bg' + (this.state.searchRequest.requesterStar ? ' active' : '')} />}
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                </div>
              )}
              {this.state.isLoading && <Loading />}
              <ProjectSearchResult search={this.state.searchRequest} searchCallback={this.updateSearchInfo} forceReload={this.state.isLoading} />
            </ClassicTitledTile>
          )}
        </div>
      </MainPagesLayout>
    );
  }
}
export default ProjectSearchPage;
